import styled from 'styled-components'
import { HEADER_HEIGHT } from 'ui/themes/variables'

export const Box = styled.main<{ $widthFooter?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0;
  height: ${(props) => (props.$widthFooter ? `calc(100vh - ${HEADER_HEIGHT})` : `auto`)};
`

export const BoxWithFooterInner = styled.div`
  flex: 1;
  overflow: auto;
`

export const BreadCrumbsWrapper = styled.div`
  font: var(--theme-typography-bodyS-semiBold);
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--theme-colors-global-grey-grey500);
  padding: 0 50px;
  height: 35px;
`

export const Footer = styled.footer`
  height: 66px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 50px 0 50px;
  background: var(--theme-colors-global-general-main);
  border-top: 1px solid var(--theme-colors-global-grey-grey300);
`
